module.exports = __webpack_public_path__ + "static/img/commodity_sing02.54a717d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/malls/commodity_sing02.png
// module id = KKgW
// module chunks = 174